<template>

 <div class="form-group">
  <p>
	{{ title }}
  </p>
  	<b-form id="attachment" enctype="multipart/form-data">
	  <b-form-group v-if="haveDesc" label="Description">
	  	<b-form-input ref="description" v-model="description" placeholder="Enter file description"></b-form-input>
	  	<small class="text-danger font-weight-bold">{{ validation.firstError('description') }}</small>
	  	<small class="text-muted">Note: Only (-) is an acceptable character.</small> 		
	  </b-form-group>
	  <b-form-group label="Filename">
	  	<!-- <input type="file" ref="fileUpload" multiple :accept="accept" class="input-file"> -->
	  	<b-form-file :file-name-formatter="formatNames" ref="fileUpload" type="file" class="form-control-file" v-model="file" :accept="accept" ></b-form-file> <!-- :accept="accept" -->
	  	<small class="text-muted">Accepted format: {{ accept }}</small>
	  	<div class="pull-right">
	  		<i class="fa fa-lightbulb-o text-warning fa-1x"></i> 
			<small class="text-muted">File must must not exceed 1MB in size.</small> 		  	
	  	</div><br>
	  	<small class="text-danger font-weight-bold">{{ validation.firstError('file') }}</small>
	  </b-form-group>	  
	</b-form>
	<span class="input-group-btn">
		<b-button @click="uploadEventHandler" variant="primary" size="sm"><i class="fa fa-upload"></i> Start Upload</b-button>	  
		<b-button @click="reset" variant="secondary" size="sm"><i class="fa fa-refresh"></i> Reset</b-button>	  
	</span>	
</div>

</template>

<script>
import fileUploadMixin from '@/mixins/validators/FileUpload-validators'
export default {
	props: {
		    title: String,
		    accept: String,
		    haveDesc: { 
		    	 type: Boolean,
		    	 default: true
		    	}
		  },
	mixins: [
    fileUploadMixin
  	],
	data() {
		return {			
			description: '',
			file: ''
		}
	},
	methods: {
		formatNames(files) {
	        if (files.length === 1) {
	          return files[0].name
	        } else {
	          return `${files.length} files selected`
	        }
      	},
		uploadEventHandler() {
			const $this = this

			if (!this.haveDesc) {
				this.description = "Convert NSL to KML"
			}
			this.$validate()
		          .then(function(success) {
		          	if (success) {
		                let obj = {file: $this.file, description: $this.description}
						$this.$emit('event-handler', obj)
		            }
		      })			
		},
		reset() {
			this.description = ''
			this.$refs.fileUpload.reset()
			this.validation.reset()
			if (this.haveDesc) {
				this.$refs.description.$el.focus()
			}
		}			
	}

}

</script>


<style></style>


// WEBPACK FOOTER //
// src/components/file-upload/FileUpload.vue